import baseRoute from '../baseRoute';

export default `${baseRoute}/workOrder` as const;
